import React from 'react';
import { Typography, Box } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';
import { 
  PercentOfCostEditor, 
  ThresholdTypeEditor, 
  ThresholdAmountEditor 
} from '../../fieldEditors/contractEditors';

const ImplantsSection: React.FC = () => {
  return (
    <SectionPaper>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
        Implants Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure implant pricing rules and thresholds.
      </Typography>
      
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { 
          xs: '1fr', 
          sm: '1fr 1fr', 
          md: '1fr 1fr 1fr' 
        }, 
        gap: 3 
      }}>
        <PercentOfCostEditor />
        <ThresholdTypeEditor />
        <ThresholdAmountEditor />
      </Box>
    </SectionPaper>
  );
};

export default ImplantsSection;